app.filter('money', [function () {
    return function (d, symbol) {
		var curTpl = '';
		let levToEvro = parseFloat(d/1.95583).toFixed(2);

		if(customCurrency){
			curTpl = "{{money}} " + customCurrency;
		}else if ( gym[0].Culture ) {
			if (gym[0].Culture == 'bg-BG') {
				if(symbol == 'evro'){
					curTpl = '(' + levToEvro + " €)";
				}else{
					curTpl = "{{money}} лв.";
				}
			}else if(gym[0].Culture.includes('-ES') || gym[0].Culture.includes('pt') || gym[0].Culture.includes('it') || gym[0].Culture.includes('ro') || gym[0].Culture.includes('lt') || gym[0].Culture.includes('de') ){
				curTpl = "{{money}}€";
				// $scope.customCurrency = 'eur';
			}else if(gym[0].Culture == "fr-CH"){
				curTpl = "CHF{{money}}";
				// $scope.customCurrency = 'CHF';
			}else if(gym[0].Culture.includes('-GB')){
				curTpl = "£{{money}}";
			}else if(gym[0].Culture == "en-ZA"){
				curTpl = "R{{money}}";
			}else {
				curTpl = "${{money}}";
				// $scope.customCurrency = '$';
			}
		}

        function formatPrice(num) {
            if (num == 0) return '0.00';
			if (num){
				num = parseFloat(num);
				return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
			}

            return '';
        }
        return curTpl.replace("{{money}}", formatPrice(d))
    }
}]);